import React from "react";
import { useSkin } from "../../skins/SkinContext";
import { skMountain, skBush, skRock, skRiver, skGrassTuft, skStar, skMoon, skRainbow } from "../../actors3/nature";
import { skButterfly, skWorm, skCat, skDog, skFish, skBird, skBee, skSnail } from "../../actors3/animals";
import { skBook, skLightbulb, skBox, skArrow, skFlag, skClock, skBall, skCup } from "../../actors3/objects";
import { skChild, skTeacher, skScientist, skRobot, skWalker, skThinker } from "../../actors3/characters";

/*
 * Anivaze v3 — the rebuilt actor library on display. Every actor is composed from
 * skinnable primitives, so the Skin picker (top-right) re-renders the WHOLE grid
 * in Studio / Hand-drawn / Flat / Doodle at once. Proof that the actor library is
 * skin-aware end-to-end. Reads the global skin (no internal provider).
 */
type ActorFn = (x: number, y: number, t: number, scale?: number) => React.ReactNode;

const ACTORS: ActorFn[] = [
  skMountain, skBush, skRock, skRiver, skGrassTuft, skStar, skMoon, skRainbow,
  skButterfly, skWorm, skCat, skDog, skFish, skBird, skBee, skSnail,
  skBook, skLightbulb, skBox, skArrow, skFlag, skClock, skBall, skCup,
  skChild, skTeacher, skScientist, skRobot, skWalker, skThinker,
];

export interface ActorGallerySceneProps {
  opacity?: number;
  accentColor?: string;
  label?: string;
  t?: number;
}

export const ActorGalleryScene: React.FC<ActorGallerySceneProps> = ({ opacity = 1, t = 0, label = "The whole actor library — pick a Skin to re-skin it all!" }) => {
  const skin = useSkin();
  const cols = 6;
  const cellW = 800 / cols;
  const top = 44;
  const rows = Math.ceil(ACTORS.length / cols);
  const cellH = (450 - top - 10) / rows;
  return (
    <g opacity={opacity}>
      <rect width={800} height={450} fill={skin.surface} />
      <text x={400} y={26} textAnchor="middle" fill={skin.textInk} fontSize={16} fontWeight={700} fontFamily={skin.fontFamily}>{label}</text>
      {ACTORS.map((fn, i) => {
        const col = i % cols;
        const row = Math.floor(i / cols);
        const cx = col * cellW + cellW / 2;
        const baseY = top + row * cellH + cellH * 0.78;
        return <g key={i}>{fn(cx, baseY, t, 0.5)}</g>;
      })}
    </g>
  );
};
